import React, {useEffect, useState} from 'react';
import { Form, Input, Select, Typography } from 'antd';
import { CreateField } from './dynamicField';
import {
    CaretDownFilled,
    SearchOutlined,
  } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { getAllFormQuery } from "@src/util/query/allForm.query";
import Spinner from "@src/components/spinner";



const multi=[
    'multiCheckbox',
    'selectDropdown',
    'radioDropdown',
];

export const FieldType = ({basicInfo, setBasicInfo, setWidth, fieldType, setFieldType})=>{
    const {Option, OptGroup} = Select;
    const [sortType, setSortType] = useState('custom');
    const [search, setSearchKeyword] = useState(null);


    const {data:getAllFormData, loading:getAllFormDataLoading} = useQuery(getAllFormQuery,{
        fetchPolicy: 'network-only'
    });


    useEffect(()=>{
        // sessionStorage.setItem('fieldType', fieldType);
        if(multi.includes(fieldType)){
            setWidth(true);
        }else{
            setWidth(false);
        }
    },[fieldType]);
    
    useEffect(()=>{
        return()=>{
          document.getElementById("nextBtn")?.classList?.remove("disabled-btn");
        }
      },[]);

    
    const systemFields = ['agency', 'branch', 'customer', 'site', 'sitegroup'];

    const {labelValue, rules} = useSelector((state) => state.createFieldReducer);

    const [currentIndex, setCurrentIndex] = useState(null);

    const handelFieldOptions = (index)=>{
        setCurrentIndex(index);
    };
    
    useEffect(()=>{
        setFieldType(fieldType?.map((field, index)=>{
            if(index==currentIndex){
                return {
                    ...field,
                    options: Object.values(labelValue)[0]
                }
            }else{
                return field;
            }
        }));
    },[labelValue, currentIndex]);



    return(
        <React.Fragment>
            <Typography className='label'>
                <Typography.Title level={4}>{basicInfo?.label}</Typography.Title>
            </Typography>

            <p style={{marginBottom: '24px', color: '#64748b'}}>How would you like to add a field to your form?</p>
            
            <div className="option-cards">
                <div className={basicInfo?.flow=="formBase"?"option-card-selected option-card": "option-card"} onClick={()=>setBasicInfo({...basicInfo, flow: 'formBase'})}>
                    <span className="option-icon">📋</span>
                    <div className="option-title">Use Existing Form</div>
                    <div className="option-desc">Select appropriate templated form for your task</div>
                </div>
                
                <div className={basicInfo?.flow=="field"?"option-card-selected option-card": "option-card"} onClick={()=>setBasicInfo({...basicInfo, flow: 'field'})}>
                    <span className="option-icon">➕</span>
                    <div className="option-title">Create New Field</div>
                    <div className="option-desc">Build a custom field from scratch with your own specifications</div>
                </div>
            </div>
            
            {basicInfo?.flow=="field"?
                fieldType?.map((field, index)=>{
                    return(

                        <Form>
                            <Form.Item className='general-form' style={{borderTop:'3px dotted lightgray', marginBottom:'16px'}}>
                                <div className='fieldNum'>{index+1}</div>
                                <label>Label <small>if any?</small> </label>
                                <Input 
                                    className='generic-input-control mb16'
                                    placeholder='Label'
                                    onChange={(e)=>setFieldType(fieldType?.map((field, i)=>{
                                        if(i==index){
                                            return {
                                                label: e?.target.value,
                                                fieldType: field?.fieldType
                                            }
                                        }else{
                                            return field;
                                        }
                                    }))}
                                    value={field?.label}
                                />

                                <label>Field type</label>
                                <Select 
                                    showSearch
                                    optionFilterProp="children"
                                    className={multi.includes(fieldType) ? "custom-select step2" : "custom-select"}
                                    suffixIcon={<span className="dropdowncaret"></span>}
                                    
                                    onChange={(e)=>{
                                        setFieldType(fieldType?.map((field, i)=>{
                                            if(i==index){
                                                return {
                                                    label: field?.label,
                                                    fieldType: e
                                                }
                                            }else{
                                                return field;
                                            }
                                        }));
                                        handelFieldOptions(index);
                                    }}
                                    placeholder="Select field type"
                                    style={{marginBottom:'26px'}}
                                    value={field?.fieldType}
                                >
                                    <OptGroup label="Lookups">
                                        <Option value="agency">Supplier Lookup</Option>
                                        <Option value="branch">Branch Lookup</Option>
                                        <Option value="customer">Customer Lookup</Option>
                                        <Option value="dutytype">Duty Type Lookup</Option>
                                        <Option value="employee">Employee Lookup</Option>
                                        <Option value="hourtype">Hour Type Lookup</Option>
                                        <Option value="site">Site Lookup</Option>
                                        <Option value="sitegroup">Site Group Lookup</Option>
                                    </OptGroup>
                                    <OptGroup label="Meta Field">
                                        <Option value="email">Email</Option>
                                        <Option value="password">Password</Option>
                                        <Option value="phone">Phone Number</Option>
                                        {/* <Option value="phone">Phone</Option> */}
                                    </OptGroup>
                                    <OptGroup label="Text Field">
                                        <Option value="singlelineText">Single-line text</Option>
                                        <Option value="multilineText">Multi-line text</Option>
                                    </OptGroup>
                                    <OptGroup label="Number">
                                        <Option value="number">Number</Option>
                                    </OptGroup>
                                    <OptGroup label="Date & Time">
                                        <Option value="date">Date picker</Option>
                                        <Option value="time">Time picker</Option>
                                        <Option value="datetime-local">Date & Time picker</Option>
                                    </OptGroup>
                                
                                    <OptGroup label="Choosing options">
                                        <Option value="singleCheckbox">Single checkbox</Option>
                                        <Option value="multiCheckbox">Multiple checkboxes</Option>
                                        <Option value="selectDropdown">Dropdown select</Option>
                                        <Option value="radioDropdown">Radio select</Option>
                                    </OptGroup>
                                    <OptGroup label="Pay Widgets">
                                        <Option value="paywidget">Pay Widget</Option>
                                        <Option value="payadjustmentwidgets">Pay Adjustment Widgets</Option>
                                    </OptGroup>
                                    <OptGroup label="Other">
                                        <Option value="file">File</Option>
                                        <Option value="signature">Signature</Option>
                                        <Option value="location">Location</Option>
                                    </OptGroup>
                                </Select>
                            </Form.Item>
            
                            {multi.includes(field?.fieldType) && 
                            <>
                                <Form.Item className='multiFieldSection'>
                                    <div style={{width:'100%'}}>
                                        <label>Sort</label>
                                        <Select
                                            className="custom-select"
                                            suffixIcon={<span className="dropdowncaret"></span>}
                                            onChange={(e)=>setSortType(e)}
                                            defaultValue="custom">
                                                <Option value="custom">Custom</Option>
                                                <Option value="alphabetical">Alphabetical</Option>
                                        </Select>
                                    </div>
                                    <div style={{width:'100%'}} className='drawer-custom-search'>
                                        <label>Search</label>
                                        <Input className="generic-input-control"  suffix={<SearchOutlined/>} onChange={(e)=>setSearchKeyword(e.target.value)} placeholder="Search" />
                                    </div>
                                </Form.Item>
                                {!systemFields.includes(field?.fieldType) && field?.fieldType?.length>0 &&
                                    <CreateField
                                        search={search}
                                        sortType={sortType} 
                                        fieldType={field?.fieldType} 
                                        label={field?.label} 
                                        preview={false}
                                        index={index}
                                        options={field?.options}
                                        handelFieldOptions={handelFieldOptions}
                                    />
                                }
                            </>
                            }
                            
                            <div style={{display:'flex',justifyContent:'end', marginBottom:'16px'}}>
                                
                                {
                                    index==fieldType?.length-1 &&
                                    <>
                                        <button className='sm-btn' onClick={()=>setFieldType([...fieldType, {label: '', fieldType: ''}])}>
                                            <FontAwesomeIcon icon={faPlus}/>    Add another field
                                        </button>

                                        {index>0? <> &emsp; <span>OR</span> &emsp; </> : null}
                                       
                                    </>

                                }
                                {
                                    index>0?
                                    <>
                                        
                                        <button 
                                            className='sm-btn'
                                            onClick={()=>setFieldType(fieldType?.filter((field, j)=> index!=j))}
                                        >
                                          <FontAwesomeIcon icon={faMinus}/>  Remove field
                                        </button>
                                    </>
                                    :null
                                }
                            </div>
                            
                        </Form>

                    
                    )
                })
                :
                basicInfo?.flow=="formBase" &&
                <Select
                    loading={getAllFormDataLoading}
                    className="custom-select"
                    suffixIcon={getAllFormDataLoading? <Spinner/> : <CaretDownFilled/>}
                    style={{margin:'0px 0 30px 0', width:'100%'}}
                    placeholder={getAllFormDataLoading? "Loading ..." :"Select form template"}
                    onChange={(e)=>{setBasicInfo({...basicInfo, formId:e});}}
                    value={basicInfo?.formId}
                >
                    {
                        getAllFormData?.getAllFormTemplate?.response?.map((form)=>(
                            <Select.Option value={form?._id}>{form?.templatename}</Select.Option>
                        ))
                    }
                </Select>
            }

            
            
        
        </React.Fragment>
    )
}